import {useEffect, useState} from 'react'

export function useIsClientSide() {
  const [clientSide, setClientSide] = useState(false)
  useEffect(() => {
    setClientSide(true)
  }, [])
  return clientSide
}
